import { displayLabel } from "../../utils/displayLabel";
import React from "react";
import { ArrowUpRight } from "lucide-react";
import { formatActivityTime, isNotificationRead } from "./circleActivityUtils";
import { ensureNotificationMeta } from "./notificationRenderer";

export default function ActivityNotification({ raw, readIds, onRead }) {
  const item = ensureNotificationMeta(raw);
  const isRead = isNotificationRead(raw, readIds);
  const safeLink = safeActivityLink(item.link);
  return <article className={`circle-update ${isRead ? "" : "circle-update-new"}`}>
    <div className="circle-update-meta"><span>{item.type === "book_release" ? "New release" : item.type === "author_update" ? "Author news" : "Circle update"}</span>{!isRead && <span className="circle-new-label">Unread</span>}<span>{formatActivityTime(item.createdAt)}</span></div>
    <h4>{safeLink ? <a href={safeLink} onClick={() => onRead([raw])}>{displayLabel(item.title)}<ArrowUpRight size={18} aria-hidden="true" /></a> : item.title}</h4>
    <div className="circle-update-footer"><span>{displayLabel(item.authorName)} · {displayLabel(item.category)}</span>{!isRead && <button type="button" onClick={() => onRead([raw])} aria-label={`Mark ${item.title} as read`}>Mark read</button>}</div>
  </article>;

}

export function safeActivityLink(value) {
  if (typeof value !== 'string' || /[\\\s]/.test(value) || Array.from(value).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127) || !/^(https?:\/\/|\/(?!\/))/.test(value)) return null;
  try {
    const url = new URL(value, 'https://bookishcircle.com');
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? value : null;
  } catch { return null; }
}
